import { PLAID_ACTION_TYPE } from "./Type";

const DEFAULT_STATE = {
	plaidCreate: { message: "", status: "idle", data: {} },
	plaidGetUpload: { message: "", status: "idle", data: {} },
	bankLinkToken: { message: "", status: "idle", data: {} },
	bankExchange: { message: "", status: "idle", data: {} },
	bankSetupIntent: { message: "", status: "idle", data: {} },
	bankConfirm: { message: "", status: "idle", data: {} },
};

const INITIAL_STATE = {
	...DEFAULT_STATE,
};

const plaid = (state = INITIAL_STATE, action) => {
	if (action.type === PLAID_ACTION_TYPE.plaidCreate) {
		return {
			...state,
			plaidCreate: action.payload,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.plaidCreateIdle) {
		return {
			...state,
			plaidCreate: DEFAULT_STATE.plaidCreate,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.plaidGetUpload) {
		return {
			...state,
			plaidGetUpload: action.payload,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.plaidGetUploadIdle) {
		return {
			...state,
			plaidGetUpload: DEFAULT_STATE.plaidGetUpload,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.bankLinkTokenSuccess || action.type === PLAID_ACTION_TYPE.bankLinkTokenError) {
		return {
			...state,
			bankLinkToken: action.payload,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.bankLinkTokenIdle) {
		return {
			...state,
			bankLinkToken: DEFAULT_STATE.bankLinkToken,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.bankExchangeSuccess || action.type === PLAID_ACTION_TYPE.bankExchangeError) {
		return {
			...state,
			bankExchange: action.payload,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.bankExchangeIdle) {
		return {
			...state,
			bankExchange: DEFAULT_STATE.bankExchange,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.bankSetupIntentSuccess || action.type === PLAID_ACTION_TYPE.bankSetupIntentError) {
		return {
			...state,
			bankSetupIntent: action.payload,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.bankSetupIntentIdle) {
		return {
			...state,
			bankSetupIntent: DEFAULT_STATE.bankSetupIntent,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.bankConfirmSuccess || action.type === PLAID_ACTION_TYPE.bankConfirmError) {
		return {
			...state,
			bankConfirm: action.payload,
		};
	}
	if (action.type === PLAID_ACTION_TYPE.bankConfirmIdle) {
		return {
			...state,
			bankConfirm: DEFAULT_STATE.bankConfirm,
		};
	}

	return state;
};

export default plaid;
